import AdminUser from 'AdminUser';
import ContentManagementInterface from '../../models/ContentManagementInterface';
import { ContentReviewInterface } from '../../models/ContentReviewInterface';
import { Palette } from 'Palette';

export interface ReviewContentEditViewProps {
  publishedContent: ContentManagementInterface;
  draftContent: ContentManagementInterface;
  reviewData: ContentReviewInterface;
  onReviewDataUpdate: (updatedData: ContentReviewInterface) => Promise<void>;
  currentUser: AdminUser;
  modelType?: 'FundOpportunity' | 'FundUpdate';
  tone?: keyof typeof Palette;
  canAddContent?: boolean;
}

export interface CommentOverlay {
  conversation: ContentReviewInterface['comments'][number];
  sectionId: string;
  top: number;
  right: number;
}

export type ReviewContentType = 'StandardHeaderText' | 'LeftRightList' | 'Table' | 'ImageCarousel';

export const REVIEW_CONTENT_TYPE_OPTIONS: ReviewContentType[] = [
  'StandardHeaderText',
  'LeftRightList',
  'Table',
  'ImageCarousel',
];
